export type ContextKind='talk'|'pickup'|'travel';
export type ContextAction={kind:ContextKind;id:string;label:string};
const priority:Record<ContextKind,number>={talk:0,pickup:1,travel:2};
/** Candidates already satisfy their domain range/ownership checks. */
export function orderedContextActions(candidates:readonly ContextAction[]):ContextAction[]{
 return [...candidates].sort((a,b)=>priority[a.kind]-priority[b.kind]||a.id.localeCompare(b.id));
}
export function contextForKey(candidates:readonly ContextAction[],key:'KeyE'|'KeyG'):ContextAction|undefined{
 return orderedContextActions(candidates).find(action=>key==='KeyG'?action.kind==='pickup':action.kind!=='pickup');
}
